import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  overlay: {
    position: "fixed",
    padding: "16px",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modal: {
    display: "flex",
    flexDirection: "column",
    width: "688px",
    maxWidth: "688px",
    borderRadius: "12px",
    background: theme.palette.background.paper,
    boxShadow:
      "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    "& p": {
      color: theme.palette.text.tertiary,
      fontWeight: 400,
      fontSize: "16px",
      margin: "4px 0 0",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
      },
    },
    [theme.breakpoints.down("sm")]: {
      maxHeight: "550px",
      overflowY: "auto",
    },
  },
  scrollDiv: {
    [theme.breakpoints.down("426")]: {
      maxHeight: "500px",
      overflowX: "auto",
      padding: "0 10px",
    },
  },

  errorMessageContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    width: "100%",
  },
  errorMessage: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 400,
    color: theme.palette.text.error_primary,
  },
  infoMessage: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 400,
    color: theme.palette.text.tertiary,
  },
  text: {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "28px",

    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  container: {
    display: "flex",
    gap: "20px",

    padding: "20px 24px 0",
    [theme.breakpoints.down("sm")]: {
      padding: "24px 16px",
      flexDirection: "column",
    },
  },
  content: {
    padding: "24px 24px 20px 24px",
    borderBottom: `1px solid ${theme.palette.border.secondary}`,
  },
  card: {
    display: "flex",
    padding: "24px",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    flex: "1 0 0",
    textAlign: "center",
    borderRadius: "12px",
    background: theme.palette.background.paper,
    cursor: "pointer",
    border: `2px solid ${theme.palette.border.secondary}`,

    "& span": {
      fontSize: "24px",
      fontWeight: 600,
      [theme.breakpoints.down("sm")]: {
        fontSize: "18px",
      },
    },

    // "&:hover": {
    //   border: `2px solid ${theme.palette.border.brandSolid}`,
    // },
  },
  activeCard: {
    border: `2px solid ${theme.palette.border.brandSolid}`,
  },
  fieldContainer: {
    display: "flex",
    gap: "32px",
    padding: "16px 0",
    margin: "0 24px",
    borderBottom: `1px solid ${theme.palette.border.secondary}`,

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },

    [theme.breakpoints.down("426")]: {
      gap: "16px",
    },

    "& span": {
      width: "228px",
      fontSize: "14px",
      fontWeight: 600,
      [theme.breakpoints.down("426")]: {
        width: "100px",
      },
    },

    "&:first-child": {
      paddingTop: "20px",
    },

    "&:last-child": {
      paddingBottom: "20px",
    },

    [theme.breakpoints.down("426")]: {
      flexWrap: "wrap",
    },
  },
  inputFullWidth: {
    width: "100% !important",
    maxWidth: "100% !important",
    [theme.breakpoints.down("426")]: {
      width: "100% !important",
    },
  },
  footerActions: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "24px",
  },
}));
